import { storeToRefs } from 'pinia'
import { useAuthStore } from '~/stores/auth'

export default defineNuxtRouteMiddleware(() => {
    const { isAuth, isProfileCompleted, isEmailVerified } = storeToRefs(
        useAuthStore(),
  )

    if (!isAuth.value) {
        return navigateTo('/login')
    }
    else if (!isEmailVerified.value) {
        return navigateTo('/login')
    }
})
